<template>
  <v-dialog v-model="dialog" persistent max-width="620px">
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="agregar()">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <!-- Toolbar Header Principal estilo Inspección -->
        <v-toolbar height="58" color="secondary" dark flat class="px-3 px-md-4">
          <v-icon left>{{ Item.id == null ? 'mdi-account-plus' : 'mdi-account-edit' }}</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Item.id == null ? "Nuevo Miembro del Cliente" : "Editar Miembro del Cliente" }}
          </span>
          <v-chip
            v-if="Item.id != null"
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-pound</v-icon>
            ID: {{ Item.id }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="cerrarDialogo()" class="btn-circle-tooltip">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4 pa-md-5">
          <!-- SECCIÓN: DATOS PERSONALES -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-account-details</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Información del Usuario Miembro
            </span>
          </div>

          <v-row dense>
            <!-- Nombres -->
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="Nombres *"
                placeholder="Ej. Carlos"
                hide-details="auto"
                v-model="Item.nombres"
                :rules="descripcionRules"
                outlined
                dense
                prepend-inner-icon="mdi-account"
                class="rounded-lg"
              ></v-text-field>
            </v-col>

            <!-- Apellidos -->
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="Apellidos *"
                placeholder="Ej. Morales Vega"
                hide-details="auto"
                v-model="Item.apellidos"
                :rules="descripcionRules"
                outlined
                dense
                prepend-inner-icon="mdi-account-outline"
                class="rounded-lg"
              ></v-text-field>
            </v-col>

            <!-- E-mail -->
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="E-mail *"
                placeholder="usuario@empresa.com"
                hide-details="auto"
                type="email"
                v-model="Item.email"
                :rules="emailRules"
                outlined
                dense
                prepend-inner-icon="mdi-email-outline"
                class="rounded-lg"
              ></v-text-field>
            </v-col>

            <!-- Rol -->
            <v-col cols="12" sm="6" class="pa-2">
              <v-autocomplete
                v-model="Item.role_id"
                :items="Roles"
                label="Seleccionar Rol *"
                placeholder="Seleccione un rol..."
                outlined
                dense
                hide-details="auto"
                prepend-inner-icon="mdi-shield-account-outline"
                :rules="descripcionRules"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-3 text-caption text--secondary">
            <v-icon x-small color="error" class="mr-1">mdi-asterisk</v-icon>
            <span>Campos obligatorios</span>
          </div>
        </v-card-text>

        <!-- Botones de Acción / Footer -->
        <v-card-actions class="pa-4 bg-light border-top d-flex justify-end align-center">
          <v-btn
            outlined
            color="grey darken-1"
            class="text-capitalize px-4 rounded-lg mr-2 font-weight-medium"
            @click="cerrarDialogo()"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            elevation="2"
            class="text-capitalize px-5 rounded-lg font-weight-bold"
            :loading="loading"
            :disabled="loading"
            @click="agregar()"
          >
            <v-icon left small>{{ Item.id == null ? 'mdi-content-save' : 'mdi-pencil' }}</v-icon>
            {{ Item.id == null ? 'Guardar Miembro' : 'Actualizar Miembro' }}
          </v-btn>
        </v-card-actions>
        <MensajeTransicion color="#FA694A" :text="mensaje" v-if="verAlerta" :top="true" :bottom="false" />
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { axios2 as axios } from "@/interceptor/useApi";
import { mapActions, mapState } from 'vuex';
import MensajeTransicion from "../Alerta.vue";

export default {
  inject: ['llamarindexMembers'],
  props: ['dialog', 'Item', "Roles"],
  components: {
    MensajeTransicion
  },
  data() {
    return {
      valid: false,
      mensaje: "",
      verAlerta: false,
      loading: false,
      emailRules: [
        (v) => !!v || "E-mail es requerido",
        (v) => /.+@.+\..+/.test(v) || "E-mail no es válido",
      ],
      descripcionRules: [(v) => !!v || "Este campo es requerido"]
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
  },
  methods: {
    ...mapActions("usercliente", ["saveMembers"]),
    async agregar() {
      let url = "";
      if (this.$refs.form && this.$refs.form.validate()) {
        this.loading = true;
        try {
          if (this.Item.id == null) {
            url = "userclientes/store";
          } else {
            url = "userclientes/update";
          }

          const datos = {
            id: this.Item.id,
            id_cliente: this.Item.id_cliente,
            email: this.Item.email,
            nombre: this.Item.nombres,
            apellidos: this.Item.apellidos,
            role_id: this.Item.role_id
          };
          await axios.post(url, datos)
            .then(() => {
              this.$alertify.success(this.Item.id == null ? "Miembro registrado correctamente" : "Miembro actualizado correctamente");
              this.cerrarDialogo();
              this.llamarindexMembers(this.$route.params.id);
            })
            .catch(error => {
              this.loading = false;
              this.mensaje = error.response && error.response.data && error.response.data.error ? error.response.data.error : "Error al procesar la solicitud";
              this.verAlerta = true;
              setTimeout(() => [(this.verAlerta = false)], 4000);
              console.error("error!", error);
            });
        } catch (error) {
          console.log(error);
          this.loading = false;
        }
      }
    },

    cerrarDialogo(valor = false) {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.loading = false;
      this.$emit('dialog', false);
      this.$emit("cerrarModal", valor);
    }
  }
};
</script>

<style scoped>
.section-title {
  border-left: 3px solid var(--v-secondary-base, #424242);
  padding-left: 8px;
}

.bg-light {
  background-color: #f8fafc !important;
}

.border-top {
  border-top: 1px solid #e2e8f0 !important;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
